import { render, staticRenderFns } from "./Round1.vue?vue&type=template&id=7882f9ae&"
import script from "./Round1.vue?vue&type=script&lang=js&"
export * from "./Round1.vue?vue&type=script&lang=js&"
import style0 from "./Round1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports